<template>
  <div>
    <a-form layout="inline">
      <a-form-item>
        <a-button v-permission="PERMISSIONS.CHANNEL_CREATE" @click="createChannel" style="margin-right: 20px; margin-bottom: 10px">创建通知通道</a-button>
        <a-input placeholder="请输入通道名称" v-model="form.channel_name" style="width: 200px; margin-right: 20px; margin-bottom: 10px"></a-input>
        <a-select placeholder="请选择途径" allowClear style="width: 200px; margin-right: 20px; margin-bottom: 10px" v-model="form.gateway">
          <a-select-option value="mail">邮件 </a-select-option>
          <a-select-option value="dingtalk">钉钉工作通知 </a-select-option>
          <a-select-option value="dingding">钉钉群通知 </a-select-option>
          <a-select-option value="dingrobot">钉钉机器人DING </a-select-option>
          <a-select-option value="wechat">微信群通知 </a-select-option>
          <a-select-option value="webhook">webhook </a-select-option>
        </a-select>
        <a-checkbox v-model="form.myCreated" style="margin-right: 20px; margin-bottom: 10px; line-height: 32px">我创建的</a-checkbox>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="search">搜索</a-button>
        <a-button @click="reset">重置</a-button>
      </a-form-item>
    </a-form>
    <a-table bordered :data-source="dataSource" :columns="columns" :pagination="false" :loading="loading" :rowKey="record => record.id">
      <template slot="id" slot-scope="record">
        <div class="copy-cell">
          <span class="ellipsis-1" :title="record.id">{{ record.id }}</span>
          <a-icon type="copy" class="copy-icon" @click="$copy(record.id)" />
        </div>
      </template>
      <template slot="gateway" slot-scope="gateway">
        <span v-if="gateway == 'mail'">{{ '邮件' }}</span>
        <span v-if="gateway == 'dingtalk'">{{ '钉钉工作通知' }}</span>
        <span v-if="gateway == 'dingding'">{{ '钉钉群通知' }}</span>
        <span v-if="gateway == 'dingrobot'">{{ '钉钉机器人DING' }}</span>
        <span v-if="gateway == 'wechat'">{{ '微信群通知' }}</span>
        <span v-if="gateway == 'webhook'">{{ 'webhook' }}</span>
      </template>
      <template slot="operation" slot-scope="record">
        <div class="button-box">
          <a-button v-permission="PERMISSIONS.CHANNEL_TEST" @click="showChannel(record)">测试</a-button>
          <a-button v-permission="PERMISSIONS.CHANNEL_UPDATE" @click="updateChannel(record)">编辑</a-button>
          <a-popconfirm title="确认复制这条消息?" ok-text="Yes" cancel-text="No" @confirm="copyChannelGroup(record)">
            <a-button v-permission="PERMISSIONS.CHANNEL_CREATE">复制</a-button>
          </a-popconfirm>
          <a-popconfirm title="确认删除这条消息?" ok-text="Yes" cancel-text="No" @confirm="deleteChannel(record)">
            <a-button v-permission="PERMISSIONS.CHANNEL_DELETE">删除</a-button>
          </a-popconfirm>
        </div>
      </template>
    </a-table>
    <div style="display: flex; justify-content: flex-end; margin-top: 10px">
      <a-pagination
        v-model="currentPage"
        :page-size-options="pageSizeOptions"
        :total="total"
        :page-size="pageSize"
        :showSizeChanger="true"
        :showQuickJumper="true"
        :show-total="total => `共 ${total} 条`"
        @change="pageChange"
        @showSizeChange="pageChange"
      />
    </div>
  </div>
</template>

<script>
import { getChannelList, deleteChannel, noticeChannelCopy } from '@/api/notice'
export default {
  data() {
    return {
      columns: [
        {
          title: 'id',
          key: 'id',
          width: 180,
          scopedSlots: { customRender: 'id' }
        },
        {
          title: '名称',
          key: 'name',
          dataIndex: 'name',
          width: '15%'
        },
        {
          title: '途径',
          dataIndex: 'gateway',
          width: '10%',
          scopedSlots: { customRender: 'gateway' }
        },
        {
          title: '描述',
          dataIndex: 'description',
          width: '15%'
        },
        {
          title: '创建用户',
          dataIndex: 'create_user',
          width: '10%'
        },
        {
          title: '创建时间',
          dataIndex: 'create_time',
          width: '15%'
        },
        {
          title: '操作',
          key: 'operation',
          scopedSlots: { customRender: 'operation' }
        }
      ],
      form: {
        channel_name: '', // 通道名称
        gateway: undefined, // 通道方式
        myCreated: false
      },
      dataSource: [],
      pageSizeOptions: ['20', '50', '100'],
      currentPage: 1,
      pageSize: 20,
      total: 1,
      loading: false
    }
  },
  created() {
    this.getChannel()
  },
  methods: {
    copyChannelGroup(data) {
      noticeChannelCopy(data.id).then(() => {
        this.$message.success('复制成功', 2)
        this.getChannel()
      })
    },
    getChannel() {
      const params = {
        page_num: this.currentPage,
        page_size: this.pageSize,
        name: this.form.channel_name,
        gateway: this.form.gateway
      }
      if (this.form.myCreated) {
        params.create_user = this.$store.state.user.name
      }
      this.loading = true
      getChannelList(params)
        .then(res => {
          this.dataSource = res.data.list
          this.total = res.data.total
          this.loading = false
        })
        .catch(() => {
          this.dataSource = []
          this.total = 0
          this.loading = false
        })
    },
    search() {
      this.currentPage = 1
      this.pageSize = 20
      const params = {
        page_num: this.currentPage,
        page_size: this.pageSize,
        name: this.form.channel_name,
        gateway: this.form.gateway
      }
      if (this.form.myCreated) {
        params.create_user = this.$store.state.user.name
      }
      this.loading = true
      getChannelList(params)
        .then(res => {
          console.log(res)
          this.dataSource = res.data.list
          this.total = res.data.total
          this.loading = false
        })
        .catch(() => {
          this.dataSource = []
          this.total = 0
          this.loading = false
        })
    },
    reset() {
      this.form = {
        channel_name: '', // 通道名称
        gateway: undefined, // 通道方式
        myCreated: false
      }
      this.pageChange(1, 20)
    },
    pageChange(page, pageSize) {
      if (this.pageSize !== pageSize) {
        this.currentPage = 1 // 分页大小变化时重置页码
        this.pageSize = pageSize
      } else {
        this.currentPage = page
      }
      this.getChannel()
    },
    showChannel(data) {
      this.$router.push({ name: 'CreateChannel', query: { type: 'test', id: data.id } })
    },
    createChannel() {
      this.$router.push({ name: 'CreateChannel', query: { type: 'create' } })
    },
    updateChannel(data) {
      this.$router.push({ name: 'CreateChannel', query: { type: 'update', id: data.id } })
    },
    deleteChannel(data) {
      deleteChannel(data.id).then(() => {
        this.$message.success('删除成功', 2)
        this.getChannel()
      })
    }
  }
}
</script>

<style scoped>
.button-box {
  display: flex;
  justify-content: space-evenly;
}

::v-deep .ant-table {
  height: calc(100vh - 300px);
  overflow: auto scroll;
}

::v-deep .ant-table .ant-table-thead {
  position: sticky;
  top: 0;
  background-color: #fff;
  /* 设置表头背景颜色 */
  z-index: 10;
  /* 设置表头层级 */
}

.ellipsis-1 {
  max-width: none;
}
</style>
